import React, { useState, useEffect, useCallback } from 'react';
import { Typography } from 'antd';
import { WarningOutlined, CloseOutlined } from '@ant-design/icons';
import { businessCardAPI } from '../../services/api';

const { Text } = Typography;

/**
 * メンテナンスメッセージ表示バナー
 *
 * 区分「UptoneMaintenanceMessage」をAPIから取得し、
 * 取得できた場合のみ赤背景の警告バナーを表示。
 *
 */
const MaintenanceMessageBanner: React.FC = () => {
  const [message, setMessage] = useState<string>('');
  const [dismissed, setDismissed] = useState<boolean>(false);
  const [hoverClose, setHoverClose] = useState<boolean>(false);

  /** メンテナンスメッセージを取得してセットする（区分「UptoneMaintenanceMessage」） */
  const loadMaintenanceMessage = useCallback(async () => {
    try {
      const response = await businessCardAPI.getComSystemMapperValueList('UptoneMaintenanceMessage');
      if (response.statuscode === 200) {
        const data = response.comsystemdatalist;
        if (data && data.length > 0) {
          setMessage(data[0].divvaluename);
        }
      } else if (response.message !== '対象データが存在しません。') {
        // データ無し（メンテナンスメッセージ未設定）は正常系のためログ出力しない。
        console.error('メンテナンスメッセージ取得エラー:', response);
      }
    } catch (error) {
      console.error('メンテナンスメッセージ取得処理中にエラーが発生しました:', error);
    }
  }, []);

  useEffect(() => {
    loadMaintenanceMessage();
  }, [loadMaintenanceMessage]);

  if (!message || dismissed) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'relative',
        padding: '12px 40px 12px 16px',
        backgroundColor: '#fff1f0',
        borderTop: '1px solid #ffa39e',
        borderBottom: '1px solid #ffa39e',
        textAlign: 'center'
      }}
    >
      <Text style={{ fontSize: '14px', color: '#cf1322', whiteSpace: 'pre-line' }}>
        <WarningOutlined style={{ marginRight: '8px' }} />
        {message.replace(/<br>/g, '\n')}
      </Text>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        onMouseEnter={() => setHoverClose(true)}
        onMouseLeave={() => setHoverClose(false)}
        aria-label="メンテナンスメッセージを閉じる"
        style={{
          position: 'absolute',
          top: '50%',
          right: '12px',
          transform: 'translateY(-50%)',
          background: 'transparent',
          border: 'none',
          padding: 4,
          cursor: 'pointer',
          color: hoverClose ? '#a8071a' : '#cf1322',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CloseOutlined style={{ fontSize: 14 }} />
      </button>
    </div>
  );
};

export default MaintenanceMessageBanner;
